import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import CommandStats from "./CommandStats";
import TopProducts from "./TopProducts";

export const Tablecommande = () => {
  const openInNewTab = (url) => {
    // 👇️ setting target to _blank with window.open
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const navigate = useNavigate();
  var urlgetlivreur =
    "https://jojomarket.ne/adminfood/functionlivreur.php?getlivreur";
  var urllistecmd =
    "https://jojomarket.ne/adminfood/functioncommande.php?listecommande";
  var urllivreur =
    "https://jojomarket.ne/adminfood/functioncommande.php?listelivreur";
  var urlattribuercmd =
    "https://jojomarket.ne/adminfood/functioncommande.php?attribuer";
  var urlsheck =
    "https://jojomarket.ne/adminfood/functioncommande.php?checkcommande";

  const [datacontent, setDatacontent] = useState([]);
  const [listelivreur, seltlistelivreur] = useState([]);
  const [sheckcommande, setSheckcommande] = useState([]);
  const [filtre, setfiltre] = useState(0);
  const [attriblivreur, setAttriblivreur] = useState(0);
  const [montantencaisse, setmontantencaisse] = useState(0);
  const [montantencaisseModal, setMontantencaisseModal] = useState(0);
  const [preset, setPreset] = useState("last30");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const handlePresetChange = (value) => {
    setPage(1);
    setPreset(value);
    if (value !== "custom") {
      setStartDate("");
      setEndDate("");
    }
  };
  const handleCustomStartChange = (value) => {
    setPage(1);
    setStartDate(value);
  };
  const handleCustomEndChange = (value) => {
    setPage(1);
    setEndDate(value);
  };
  const buildQuery = () => {
    const params = new URLSearchParams();
    if (preset && preset !== "custom") params.append("preset", preset);
    if (preset === "custom" && startDate && endDate) {
      params.append("startDate", startDate);
      params.append("endDate", endDate);
    }
    if (searchTerm && searchTerm.trim() !== "") {
      params.append("recherche", searchTerm.trim());
    }
    params.append("page", page);
    params.append("limit", limit);
    return params.toString();
  };

  const getListUrl = () => {
    const query = buildQuery();
    return query ? `${urllistecmd}&${query}` : urllistecmd;
  };

  const getCountUrl = () => {
    const query = buildQuery();
    const baseCountUrl =
      "https://jojomarket.ne/adminfood/functioncommande.php?listecommande_count";
    return query ? `${baseCountUrl}&${query}` : baseCountUrl;
  };

  useEffect(() => {
    const urlsheckLocal =
      "https://jojomarket.ne/adminfood/functioncommande.php?checkcommande";
    loadContent(urllivreur);
    loadCount();
    loadSheck(urlsheckLocal);
  }, [preset, startDate, endDate, page, limit, searchTerm]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      loadSheck(urlsheck);
    }, 20000);
    return () => clearInterval(intervalId);
  }, []);

  const modifstock = async (idproduit, stock) => {
    var urlmodifstock =
      "https://jojomarket.ne/adminfood/functionproduit.php?addstock&idproduit=" +
      idproduit +
      "&stock=" +
      stock;
    const responsemodif = await axios.get(urlmodifstock);
    document.getElementById(idproduit).innerText = stock;
  };
  const suppression = async (idproduit) => {
    var urlsup =
      "https://jojomarket.ne/adminfood/functionproduit.php?supprimer&idproduit=" +
      idproduit;
    const responsemodif = await axios.get(urlsup);
    // document.getElementById(idproduit).innerText = stock;
    // window.location.reload();
    //this.Tableproduit(props);
  };
  // const handleChange(event){

  // }

  const loadSheck = async (urlsheck) => {
    const responsesheck = await axios.get(urlsheck);
    setSheckcommande(responsesheck.data);
  };

  const loadContent = async (urllivreur) => {
    const response = await axios.get(getListUrl());
    setDatacontent(response.data);
    const responselivreur = await axios.get(urllivreur);
    seltlistelivreur(responselivreur.data);
  };

  const loadCount = async () => {
    try {
      const res = await axios.get(getCountUrl());
      setTotalCount(parseInt(res.data) || 0);
    } catch (e) {
      setTotalCount(0);
    }
  };

  const attribuerreapide = async (idcommande, idlivreur, commandeData) => {
    var urlmodifstock =
      "https://jojomarket.ne/adminfood/functioncommande.php?attribuer&idcommande=" +
      idcommande +
      "&idlivreur=" +
      idlivreur;
    const responsemodif = await axios.get(urlmodifstock);
    
    // Trouver le livreur pour récupérer son téléphone
    const livreur = listelivreur.find(l => l.idlivreur == idlivreur);
    
    if (livreur && livreur.telephone && commandeData) {
      // Construire le message WhatsApp
      let message = `🍽️ *NOUVELLE COMMANDE #${idcommande}*\n\n`;
      
      // Informations client
      if (commandeData.clientcmd && commandeData.clientcmd.length > 0) {
        const client = commandeData.clientcmd[0];
        message += `👤 *Client:*\n`;
        message += `   Nom: ${client.nomclient}\n`;
        message += `   Téléphone: ${client.telephoneclient}\n\n`;
      }
      
      // Adresse
      if (commandeData.adresse) {
        message += `📍 *Adresse de livraison:*\n${commandeData.adresse}\n\n`;
      }
      
      // Liste des produits
      message += `🛒 *Détails de la commande:*\n`;
      if (commandeData.listeproduit && commandeData.listeproduit.length > 0) {
        commandeData.listeproduit.forEach((produit, index) => {
          const quantite = produit.quantite || 0;
          const prix = produit.prix || 0;
          const total = quantite * prix;
          message += `${index + 1}. ${produit.nomproduit}\n`;
          message += `   Quantité: ${quantite} x ${prix.toLocaleString('fr-FR')} FCFA = ${total.toLocaleString('fr-FR')} FCFA\n\n`;
        });
      }
      
      // Total
      if (commandeData.prix) {
        message += `💰 *Total: ${parseFloat(commandeData.prix).toLocaleString('fr-FR')} FCFA*\n\n`;
      }
      
      // Date
      if (commandeData.datecommande) {
        const date = new Date(commandeData.datecommande);
        message += `📅 Date: ${date.toLocaleString('fr-FR')}\n`;
      }
      
      message += `\n✅ Merci de procéder à la livraison!`;
      
      // Nettoyer le numéro de téléphone (enlever les espaces, +, etc.)
      const telLivreur = livreur.telephone.replace(/[^0-9]/g, '');
      
      // Générer le lien WhatsApp
      const whatsappUrl = `https://wa.me/${telLivreur}?text=${encodeURIComponent(message)}`;
      
      // Ouvrir WhatsApp dans un nouvel onglet
      window.open(whatsappUrl, '_blank');
    }
    
    loadContent(urllivreur);
  };

  const functionencaisse = async (idcommande, montant) => {
    var urlencaisse =
      "https://jojomarket.ne/adminfood/functioncommande.php?encaisse&idcommande=" +
      idcommande +
      "&montant=" +
      montant;
    const responsemodif = await axios.get(urlencaisse);
    //document.getElementById(i).innerText = stock;
    loadContent(urllivreur);
  };

  const functionencaisseModal = async (idcommande, montant) => {
    var urlencaisse =
      "https://jojomarket.ne/adminfood/functioncommande.php?encaisse&idcommande=" +
      idcommande +
      "&montant=" +
      montant;
    const responsemodif = await axios.get(urlencaisse);
    loadContent(urllivreur);
    // Fermer la modal après encaissement
    const modal = document.getElementById(`detailModal${idcommande}`);
    if (modal) {
      const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    }
  };

  return (
    <div>
      {/* Section des statistiques et top produits */}
      <div className="row my-4">
        <div className="col-lg-8 col-md-12 mb-md-0 mb-4">
          <CommandStats
            preset={preset}
            startDate={startDate}
            endDate={endDate}
            onPresetChange={handlePresetChange}
            onStartDateChange={handleCustomStartChange}
            onEndDateChange={handleCustomEndChange}
          />
        </div>
        <div className="col-lg-4 col-md-12 mb-md-0 mb-4">
          <TopProducts />
        </div>
      </div>
      
      {/* Section de gestion des commandes */}
      <div className="row my-4">
        <div className="col-lg-12 col-md-12 mb-md-0 mb-4">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row align-items-center">
                <div className="col-lg-4 col-md-6 col-12 mb-2 mb-lg-0">
                  <h6 className="mb-0">Gestion des commandes</h6>
                </div>
                <div className="col-lg-4 col-md-6 col-12 mb-2 mb-lg-0">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Rechercher par n° commande, nom ou téléphone..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setPage(1); // Reset to first page on search
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                        }
                      }}
                    />
                    {searchTerm && (
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => {
                          setSearchTerm('');
                          setPage(1);
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-12 text-lg-end">
                  {sheckcommande ? (
                    <button
                      type="button"
                      className="btn btn-warning btn-sm w-100 w-lg-auto text-start text-lg-end d-flex align-items-center justify-content-between gap-2"
                      onClick={() => loadContent(urllivreur)}
                    >
                      <span className="fw-bold">
                        {sheckcommande} Nouvelle(s) commande(s)
                      </span>
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  ) : null}
                </div>
              </div>
              <div className="row align-items-center mt-3">
                <div className="col-lg-8 col-md-12 mb-2 mb-lg-0">
                  <div className="btn-group flex-wrap" role="group">
                    <button
                      type="button"
                      className={`btn btn-sm ${filtre === 0 ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setfiltre(0)}
                    >
                      <i className="fas fa-clock me-1"></i>
                      Nouvelles
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${filtre === 1 ? 'btn-warning' : 'btn-outline-warning'}`}
                      onClick={() => setfiltre(1)}
                    >
                      <i className="fas fa-truck me-1"></i>
                      En cours
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${filtre === 2 ? 'btn-success' : 'btn-outline-success'}`}
                      onClick={() => setfiltre(2)}
                    >
                      <i className="fas fa-check-circle me-1"></i>
                      Livrées
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12">
                  <div className="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center gap-2">
                    <select
                      className="form-select form-select-sm"
                      value={preset}
                      onChange={(e) => handlePresetChange(e.target.value)}
                    >
                      <option value="last30">Dernières commandes (30 derniers jours)</option>
                      <option value="today">Aujourd'hui</option>
                      <option value="yesterday">Hier</option>
                      <option value="this_week">Cette semaine</option>
                      <option value="this_month">Ce mois-ci</option>
                      <option value="last7">7 derniers jours</option>
                      <option value="custom">Plage personnalisée</option>
                    </select>
                    {preset === 'custom' && (
                      <div className="d-flex flex-column flex-sm-row gap-2">
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={startDate}
                          onChange={(e) => handleCustomStartChange(e.target.value)}
                        />
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={endDate}
                          onChange={(e) => handleCustomEndChange(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body px-0 pb-2">
              <div className="table-responsive">
                <table className="table align-items-center mb-0 table-hover">
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Action
                      </th>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Commande
                      </th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Client
                      </th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Montant
                      </th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Date
                      </th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {datacontent &&
                      datacontent.map((item, index) => (
                        <>
                          {item.statu == filtre ? (
                            <tr 
                              key={item.idcommande}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                // Ouvrir la modal avec les détails de la commande
                                const modal = new window.bootstrap.Modal(document.getElementById(`detailModal${item.idcommande}`));
                                modal.show();
                              }}
                            >
                              <td className="align-middle" onClick={(e) => e.stopPropagation()}>
                                <span className="text-xs font-weight-bold">
                                  <span className="badge">
                                    <div className="dropdown float-lg-end pe-4">
                                      <a
                                        className="cursor-pointer btn btn-sm btn-outline-secondary"
                                        id={`dropdownTable${item.idcommande}`}
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        style={{ minWidth: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}
                                      >
                                        ⋮
                                      </a>
                                      <ul
                                        className="dropdown-menu px-2 py-3 ms-sm-n4 ms-n5"
                                        aria-labelledby={`dropdownTable${item.idcommande}`}
                                        style={{}}
                                      >
                                        {item.statu == 0 ? (
                                          <li>
                                            <a
                                              className="dropdown-item border-radius-md"
                                              data-bs-toggle="modal"
                                              data-bs-target={
                                                "#attribuer" + item.idcommande
                                              }
                                            >
                                              Attribuer
                                            </a>
                                          </li>
                                        ) : item.statu == 1 ? (
                                          <li>
                                            <a
                                              className="dropdown-item border-radius-md"
                                              data-bs-toggle="modal"
                                              data-bs-target={
                                                "#encaisse" + item.idcommande
                                              }
                                            >
                                              Encaissé
                                            </a>
                                          </li>
                                        ) : (
                                          <span class="badge badge-sm bg-gradient-success">
                                            Encaissé
                                          </span>
                                        )}
                                      </ul>
                                      <div
                                        className="modal fade"
                                        id={"encaisse" + item.idcommande}
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-labelledby="modal-form"
                                        aria-hidden="true"
                                        style={{}}
                                      >
                                        <div
                                          className="modal-dialog modal-dialog-centered "
                                          role="document"
                                        >
                                          <div className="modal-content">
                                            <div className="modal-body p-0">
                                              <div className="card card-plain">
                                                <div className="card-header pb-0 text-left">
                                                  <h3 className="font-weight-bolder text-info text-gradient">
                                                    Encaissser
                                                  </h3>
                                                  <span className="text-xs font-weight-bold" style={{textAlign:"left"}}>
                                                    {item.listeproduit.map(
                                                      (skillDetail) => {
                                                        return (
                                                          <div
                                                            style={{
                                                              color: "black",fontSize:14
                                                            }}
                                                          >
                                                            {
                                                              skillDetail.nomproduit
                                                            }{" "}
                                                            -{" "}<span style={{color:"red",fontSize:17,fontWeight:"bold"}}>
                                                            {
                                                              skillDetail.quantite
                                                            }
                                                            </span>
                                                            <br />
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </span><br/>
                                                  <h5 style={{color:"red"}}>valeur : {item.prix}</h5>
                                                </div>
                                                <div className="card-body">
                                                  <form role="form text-left ">
                                                   
                                                    <div className="  row" style={{height:"10vh"}}>
                                                      <input
                                                        type="number"
                                                        className="form-control  mb-1 col-md-8"
                                                        onChange={(e) =>
                                                          setmontantencaisse(
                                                            e.target.value
                                                          )
                                                        }
                                                        placeholder=""
                                                        aria-label="Email"
                                                        aria-describedby="email-addon"
                                                      />

                                                      <div
                                                        className="btn"
                                                        onClick={(e) => {
                                                          const value = parseFloat(montantencaisse);
                                                          if (!value || value <= 0) {
                                                            alert('Veuillez saisir un montant valide');
                                                            return;
                                                          }
                                                          functionencaisse(
                                                            item.idcommande,
                                                            value
                                                          );
                                                        }}
                                                        data-bs-dismiss="modal"
                                                      >
                                                        
                                                        Valider
                                                      </div>
                                                    </div>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="modal fade"
                                        id={"attribuer" + item.idcommande}
                                        tabindex="-1"
                                        role="dialog"
                                        aria-labelledby="modal-notification"
                                        aria-hidden="true"
                                      >
                                        <div
                                          class="modal-dialog modal-danger modal-dialog-centered modal-"
                                          role="document"
                                        >
                                          <div class="modal-content">
                                            <div class="modal-header">
                                              <h6
                                                class="modal-title"
                                                id="modal-title-notification"
                                              >
                                                Attribuer A Un Livreur
                                              </h6>
                                              <button
                                                type="button"
                                                class="btn-close text-dark"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                              >
                                                <span aria-hidden="true">
                                                  ×
                                                </span>
                                              </button>
                                            </div>
                                            <div class="modal-body">
                                              <div class="py-3 text-center">
                                                <div class="card-body">
                                                  <form role="form text-left">
                                                    <div class="form-group">
                                                      <input
                                                        type="text"
                                                        placeholder="Regular"
                                                        name="idcommande"
                                                        value={item.idcommande}
                                                        class="form-control"
                                                        disabled
                                                      />
                                                    </div>
                                                    <div class="form-group">
                                                      <select
                                                        class="form-control"
                                                        id="idlivreur"
                                                        value={item.idlivreur}
                                                        onChange={(e) =>
                                                          setAttriblivreur(
                                                            e.target.value
                                                          )
                                                        }
                                                        name="idlivreur"
                                                      >
                                                        <option key="defaut">
                                                          Choisir un livreur
                                                        </option>
                                                        {listelivreur &&
                                                          listelivreur.map(
                                                            (
                                                              itemlive,
                                                              index
                                                            ) => (
                                                              <option
                                                                key={
                                                                  itemlive.idlivreur
                                                                }
                                                                value={
                                                                  itemlive.idlivreur
                                                                }
                                                                data-bs-dismiss="modal"
                                                              >
                                                                {
                                                                  itemlive.nomlivreur
                                                                }
                                                              </option>
                                                            )
                                                          )}
                                                      </select>
                                                      <div
                                                        className="form-control btn  col-md-12"
                                                        onClick={(e) => {
                                                          if (!attriblivreur || attriblivreur === 'defaut' || attriblivreur === 0) {
                                                            alert('Sélectionnez un livreur');
                                                            return;
                                                          }
                                                          attribuerreapide(
                                                            item.idcommande,
                                                            attriblivreur,
                                                            item
                                                          );
                                                        }}
                                                        data-bs-dismiss="modal"
                                                      >
                                                        {" "}
                                                        Valider{" "}
                                                      </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                      <button
                                                        type="button"
                                                        class="btn btn-link text-black ml-auto"
                                                        data-bs-dismiss="modal"
                                                      >
                                                        Fermer
                                                      </button>
                                                    </div>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </span>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <div className="d-flex flex-column">
                                  <span className="text-xs font-weight-bold text-primary">
                                    #{item.idcommande}
                                  </span>
                                  <small className="text-muted">
                                    {item.listeproduit.length} article(s)
                                  </small>
                                </div>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <div className="d-flex flex-column">
                                <span className="text-xs font-weight-bold">
                                  {item.clientcmd.map((clientDetail) => {
                                    return <>{clientDetail.nomclient}</>;
                                  })}
                                </span>
                                  <small className="text-muted">
                                  {item.clientcmd.map((clientDetail2) => {
                                    return <>{clientDetail2.telephoneclient}</>;
                                  })}
                                  </small>
                                </div>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <span className="text-xs font-weight-bold text-success">
                                  {(parseFloat(item.prix) || 0).toLocaleString('fr-FR')} FCFA
                                </span>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <span className="text-xs font-weight-bold">
                                  {new Date(item.datecommande).toLocaleDateString('fr-FR')}
                                </span>
                              </td>
                              <td className="align-middle">
                                <span className="text-xs font-weight-bold">
                                  {item.statu == 0 ? (
                                    <span className="badge badge-sm bg-gradient-danger">
                                      Non Validé
                                    </span>
                                  ) : item.statu == 1 ? (
                                    <span className="badge badge-sm bg-gradient-warning">
                                      En cours
                                    </span>
                                  ) : (
                                    <span className="badge badge-sm bg-gradient-success">
                                      Livré
                                    </span>
                                  )}
                                </span>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}{" "}
                        </>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center px-3">
                <div>
                  <select className="form-select form-select-sm" style={{width: '90px'}} value={limit} onChange={(e)=>{setPage(1); setLimit(parseInt(e.target.value) || 20)}}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <div className="pagination mb-0">
                  <button className="btn btn-sm btn-outline-secondary me-2" disabled={page<=1} onClick={()=> setPage(page-1)}>Précédent</button>
                  <span className="text-sm">Page {page} / {Math.max(1, Math.ceil(totalCount / limit))}</span>
                  <button className="btn btn-sm btn-outline-secondary ms-2" disabled={(page*limit) >= totalCount} onClick={()=> setPage(page+1)}>Suivant</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Modals de détails des commandes */}
        {datacontent &&
          datacontent.map((item, index) => (
            <div
              key={`modal-${item.idcommande}`}
              className="modal fade"
              id={`detailModal${item.idcommande}`}
              tabIndex={-1}
              role="dialog"
              aria-labelledby="detailModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header bg-gradient-primary">
                    <h5 className="modal-title text-white" id="detailModalLabel">
                      <i className="fas fa-shopping-cart me-2"></i>
                      Détails de la commande #{item.idcommande}
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <h6 className="text-primary mb-3">
                          <i className="fas fa-user me-2"></i>Informations Client
                        </h6>
                        <div className="card bg-light">
                          <div className="card-body">
                            {item.clientcmd.map((clientDetail, idx) => (
                              <div key={idx}>
                                <p className="mb-1">
                                  <strong>Nom:</strong> {clientDetail.nomclient}
                                </p>
                                <p className="mb-1">
                                  <strong>Téléphone:</strong> {clientDetail.telephoneclient}
                                </p>
                              </div>
                            ))}
                            <p className="mb-0">
                              <strong>Adresse:</strong> {item.adresse}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <h6 className="text-primary mb-3">
                          <i className="fas fa-info-circle me-2"></i>Informations Commande
                        </h6>
                        <div className="card bg-light">
                          <div className="card-body">
                            <p className="mb-1">
                              <strong>Date:</strong> {new Date(item.datecommande).toLocaleString('fr-FR')}
                            </p>
                            <p className="mb-1">
                              <strong>Status:</strong> 
                              {item.statu == 0 ? (
                                <span className="badge bg-danger ms-2">Non Validé</span>
                              ) : item.statu == 1 ? (
                                <span className="badge bg-warning ms-2">En cours</span>
                              ) : (
                                <span className="badge bg-success ms-2">Livré</span>
                              )}
                            </p>
                            <p className="mb-0">
                              <strong>Montant Total:</strong> 
                              <span className="text-success fw-bold ms-2">
                                {(parseFloat(item.prix) || 0).toLocaleString('fr-FR')} FCFA
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mt-4">
                      <h6 className="text-primary mb-3">
                        <i className="fas fa-box me-2"></i>Articles Commandés
                      </h6>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Produit</th>
                              <th className="text-center">Quantité</th>
                              <th className="text-center">Prix Unitaire</th>
                              <th className="text-center">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.listeproduit.map((product, idx) => {
                              const quantite = parseInt(product.quantite) || 0;
                              const prix = parseFloat(product.prix) || 0;
                              const total = quantite * prix;
                              
                              return (
                                <tr key={idx}>
                                  <td>{product.nomproduit}</td>
                                  <td className="text-center">
                                    <span className="badge bg-primary">{quantite}</span>
                                  </td>
                                  <td className="text-center">{prix.toLocaleString('fr-FR')} FCFA</td>
                                  <td className="text-center text-success fw-bold">
                                    {total.toLocaleString('fr-FR')} FCFA
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    
                    <div className="mt-3">
                      <h6 className="text-primary mb-3">
                        <i className="fas fa-map-marker-alt me-2"></i>Localisation
                      </h6>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted">{item.adresse}</span>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() =>
                            openInNewTab(
                              "https://maps.google.com/?q=" +
                                item.latitude +
                                "," +
                                item.longitude
                            )
                          }
                        >
                          <i className="fas fa-map me-1"></i>
                          Voir sur la carte
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    {item.statu == 1 && (
                      <div className="d-flex align-items-center me-3">
                        <input
                          type="number"
                          className="form-control me-2"
                          style={{ width: "120px" }}
                          placeholder="Montant"
                          value={montantencaisseModal}
                          onChange={(e) => setMontantencaisseModal(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => functionencaisseModal(item.idcommande, montantencaisseModal)}
                        >
                          <i className="fas fa-money-bill-wave me-1"></i>
                          Encaisser
                        </button>
                      </div>
                    )}
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    
  );
};

export default Tablecommande;